var r = "1.49.2";
export {
  r as version
};
//# sourceMappingURL=index20.js.map
